export enum SelectOptionReponses {
  Yes = 1,
  No = 2,
}
